import { Box, Button, Stack } from '@mui/material'
import React, { useEffect, useState } from 'react'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import Divider from '@mui/material/Divider'
import ListItemText from '@mui/material/ListItemText'
import ListItemAvatar from '@mui/material/ListItemAvatar'
import Avatar from '@mui/material/Avatar'
import Typography from '@mui/material/Typography'
import MarkAsUnreadIcon from '@mui/icons-material/MarkAsUnread'
import BookmarkIcon from '@mui/icons-material/Bookmark'
import HomeRepairServiceIcon from '@mui/icons-material/HomeRepairService'
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth'
import DoneAllIcon from '@mui/icons-material/DoneAll'
import { makeGetRequest } from 'utils/api'
import moment from 'moment'
import { toast } from 'react-toastify'
import { makePostRequest } from 'utils/api'
import CreateTask from './CreateTask'
import CreateEvent from './CreateEvent'

export default function Traning() {
  const [traninglist, setTraningList] = useState([])
  const [filterTraninglist, setFilterTraningList] = useState([])
  const [selectedTraning, setSelectedTraning] = useState(false)
  const [createTache, setCreateTache] = useState(false)
  const [createEvent, setCreateEvent] = useState(false)

  useEffect(() => {
    getTraningList()
  }, [])

  const handleJob = async (traning, status) => {
    const payload = { id: traning.id, status: status }
    const res = await makePostRequest('/api/Professional/tranings-status/', payload, {}, true)
    if (res.status === 200) {
      toast(`${traning.title} successfully ${status}`, {
        position: 'top-right',
        autoClose: 4000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        theme: 'dark',
        pauseOnFocusLoss: false,
      })
    }
  }
  const getTraningList = async () => {
    const res = await makeGetRequest('/api/Professional/tranings/', {}, true)
    if (res.status === 200) {
      setTraningList(res.data)
      setFilterTraningList(res.data)
    }
  }
  const handleInputChange = (event) => {
    let query = event.target.value
    if (query !== '') {
      setFilterTraningList(
        traninglist.filter((el) => el.title.toLowerCase().includes(query.toLowerCase())),
      )
    } else {
      setFilterTraningList(traninglist)
    }
  }
  const handleCreateTask = () => {
    setCreateTache(true)
  }
  const handleCreateEvent = () => {
    setCreateEvent(true)
  }
  const toggleModal = () => {
    setCreateEvent(false)
  }
  return (
    <>
      {createEvent && <CreateEvent toggleModal={toggleModal} title={selectedTraning.title} />}
      {createTache && <CreateTask setCreateTache={setCreateTache} title={selectedTraning.title} />}
      <Box display={'flex'}>
        <Box minWidth={390} height={'82vh'} p={1}>
          <Box fontSize={'larger'} fontWeight={'600'}>
            Offers d'emploi ({filterTraninglist.length})
          </Box>
          <Box width={'100%'} py={2}>
            <input
              onChange={handleInputChange}
              placeholder="Lieux"
              style={{ width: '100%', borderRadius: 10, padding: '2px 10px' }}
            />
          </Box>
          {filterTraninglist.length > 0 ? (
            <List sx={{ width: '100%' }}>
              {filterTraninglist.map((traning, index) => (
                <ListItem
                  key={index}
                  alignItems="flex-start"
                  sx={{
                    borderBottom: '1px solid gray',
                    px: 1,
                    cursor: 'pointer',
                    background:
                      selectedTraning && selectedTraning.id === traning.id ? '#80808040' : '',
                  }}
                  onClick={() => setSelectedTraning(traning)}
                >
                  <ListItemAvatar>
                    <img src="/jobpic.png" alt="" style={{ height: 70 }} />
                  </ListItemAvatar>
                  <ListItemText
                    sx={{ '.MuiTypography-body1': { fontSize: 20, fontWeight: 700 } }}
                    primary={traning.title}
                    secondary={
                      <>
                        <Typography
                          component="span"
                          variant="body2"
                          sx={{ color: 'white', display: 'inline' }}
                        >
                          {traning.provider}
                        </Typography>
                        <Box color={'gray'}>{traning.duration}</Box>
                        <Box color={'gray'} mt={1}>
                          {moment(traning.created_at).format('MMMM Do YYYY, h:mm:ss a')}
                        </Box>
                      </>
                    }
                  />
                  <ListItemAvatar>
                    <MarkAsUnreadIcon />
                    <BookmarkIcon />
                  </ListItemAvatar>
                </ListItem>
              ))}
            </List>
          ) : (
            <Box>No jobs found...</Box>
          )}
        </Box>
        <Box width={'100%'} px={3} py={1}>
          {selectedTraning ? (
            <Box>
              <Box display={'flex'} alignItems={'center'}>
                <Box>
                  <img src="/jobpic.png" alt="" style={{ height: 70 }} />
                </Box>
                <Box sx={{ fontSize: 25, fontWeight: 700 }}>{selectedTraning.provider}</Box>
              </Box>
              <Box mt={2} fontSize={25} fontWeight={700}>
                {selectedTraning.title}
              </Box>
              <Box display={'flex'} alignItems={'center'} fontSize={18}>
                <HomeRepairServiceIcon />
                <Box mt={'2px'} ml={1}>
                  {selectedTraning.duration}
                </Box>
              </Box>
              <Box mt={2}>
                <strong>Start:</strong>{' '}
                {moment(selectedTraning.start_date).format('MMMM Do YYYY, h:mm:ss a')}
              </Box>
              <Box mt={2}>
                <strong>End:</strong>{' '}
                {moment(selectedTraning.end_date).format('MMMM Do YYYY, h:mm:ss a')}
              </Box>
              <Box mt={2}>
                <Stack direction="row" spacing={2}>
                  <Button
                    size="large"
                    variant="contained"
                    sx={{
                      background: '#196081',
                      '&:hover': { background: '#4589a9' },
                      alignItems: 'center',
                    }}
                    startIcon={<MarkAsUnreadIcon />}
                    onClick={() => handleJob(selectedTraning, 'Postuler')}
                  >
                    Postuler
                  </Button>
                  <Button
                    size="large"
                    variant="contained"
                    sx={{
                      background: '#196081',
                      '&:hover': { background: '#4589a9' },
                      alignItems: 'center',
                    }}
                    startIcon={<BookmarkIcon />}
                    onClick={() => handleJob(selectedTraning, 'Enregistrer')}
                  >
                    Enregistrer
                  </Button>
                  <Button
                    size="large"
                    variant="contained"
                    sx={{
                      background: '#196081',
                      '&:hover': { background: '#4589a9' },
                      alignItems: 'center',
                    }}
                    startIcon={<DoneAllIcon />}
                    onClick={handleCreateTask}
                  >
                    To Do
                  </Button>
                  <Button
                    size="large"
                    variant="contained"
                    sx={{
                      background: '#196081',
                      '&:hover': { background: '#4589a9' },
                      alignItems: 'center',
                    }}
                    startIcon={<CalendarMonthIcon />}
                    onClick={handleCreateEvent}
                  >
                    événement
                  </Button>
                </Stack>
              </Box>
              <Box mt={2} fontSize={25} fontWeight={700}>
                à offre formation
              </Box>
              <Box mt={3}>{selectedTraning.description}</Box>
            </Box>
          ) : (
            <Box></Box>
          )}
        </Box>
      </Box>
    </>
  )
}
